export interface SettingsWidgetContentRouter {
  goBack(prevState: { pathname: string; search: string }): void;
  goToList(query?: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingsWidgetContentRouter = Symbol(
  'SettingsWidgetContentRouter',
);
